import { Box, Button, Link, Page, Text, TextField } from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import { useHistory } from "react-router";
import { PolarisCard } from "src/components/shopify/PolarisCard";
import { useResendSupplierOtpMutation, useVerifySupplierOtpMutation } from "src/graphql/codegen_graphql";
import { Toast } from "src/hooks/toast";

export function VerificationScreen() {
  const q = new URLSearchParams(window.location.search);
  const history = useHistory();
  const [passkey, setPasskey] = useState(q.get("passkey") || "");
  const [otpInput, setOtpInput] = useState(["", "", "", ""]);
  const [focus, setFocus] = useState(0);
  const [verifyOtp, { loading: loading1 }] = useVerifySupplierOtpMutation();
  const [resendOtp, { loading: loading2 }] = useResendSupplierOtpMutation();

  const handleChangeInput = useCallback(
    (value, index) => {
      const v = [...otpInput];
      v[index] = value;
      setOtpInput(v);
      value !== "" && index < v.length && setFocus(index + 1);
      value === "" && index > 0 && setFocus(index - 1);
    },
    [otpInput],
  );

  const handleVerify = useCallback(() => {
    verifyOtp({
      variables: {
        verifyToken: passkey,
        secretCode: otpInput.join(""),
        isSeller: true,
        verifyForgeted: false,
      },
    }).then((res) => {
      if (!!res.data?.verifySupplierOtp?.success) {
        if (res.data.verifySupplierOtp.status === "VERIFIED") {
          Toast.onShow(res.data?.verifySupplierOtp?.message || "", "success", "right");
          setTimeout(() => {
            history.push({
              pathname: "/",
            });
          }, 500);
        }
      } else {
        Toast.onShow(res.data?.verifySupplierOtp?.message || "", "danger", "right");
      }
    });
  }, [history, otpInput, passkey, verifyOtp]);

  const handleResendOtp = useCallback(() => {
    resendOtp({
      variables: {
        verifyToken: passkey,
        verifyForgeted: false,
      },
    }).then((res) => {
      if (res.data?.resendSupplierOtp?.success) {
        Toast.onShow(res.data.resendSupplierOtp.message || "", "success", "right");
        setPasskey(res.data.resendSupplierOtp.token || "");
        q.set("passkey", res.data.resendSupplierOtp.token || "");
        history.push({
          pathname: history.location.pathname,
          search: q.toString(),
        });
      }
    });
  }, [q, history, passkey, resendOtp]);

  return (
    <Page>
      <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 500 }}>
        <PolarisCard padding={"300"}>
          <Box padding={"300"}>
            <Text as="h3" variant="headingXl" alignment="center">
              Enter the code
            </Text>
          </Box>
          <Box padding={"300"}>
            <Text as="p" variant="bodyMd" alignment="center">
              We sent a code to your phone number or email to confirm.
            </Text>
          </Box>
          <Box padding={"300"}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ display: "flex", justifyContent: "space-between", width: 300 }}>
                {[...new Array(4)].map((x, i) => {
                  return (
                    <div key={i} style={{ width: 40 }}>
                      <TextField
                        focused={focus === i}
                        onChange={(v) => handleChangeInput(v, i)}
                        label=""
                        align="center"
                        labelHidden
                        value={otpInput[i]}
                        autoComplete="off"
                        maxLength={1}
                        minLength={1}
                        loading={loading1 || loading2}
                        disabled={loading1 || loading2}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </Box>
          <br />
          <Box padding={"300"}>
            <Button
              fullWidth
              tone="success"
              variant="primary"
              loading={loading1 || loading2}
              disabled={loading1 || loading2}
              onClick={handleVerify}
            >
              Verify Account
            </Button>
          </Box>
          <Box padding={"300"}>
            <Text as="p" variant="bodyMd" alignment="center">
              If you not receive code or code was expire. <Link onClick={handleResendOtp}>Resend Code</Link>
            </Text>
          </Box>
        </PolarisCard>
      </div>
    </Page>
  );
}
